export const TWITTER_LINK = "https://twitter.com/DanielStefanK";
export const INSTA_LINK = "https://www.instagram.com/ddaniel.stefan/";
export const LINKEDIN_LINK =
  "https://www.linkedin.com/in/daniel-stefan-klose-57a849a7/";
